import { container } from '../../../DataDomain';
import { IMpxFilmographyResponse } from '../../../entity/interface/iMpxVodResponse';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IGetFilmographyUseCase {
    execute(byCustomValue: string, personId: string): Promise<IMpxFilmographyResponse>;
}

export class GetFilmographyUsecase implements IGetFilmographyUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(byCustomValue: string, personId: string): Promise<IMpxFilmographyResponse> {
        return await this.mpxRepository.getFilmography(byCustomValue, personId);
    }
}
